<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">Termini</h3>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
                <li class="m-portlet__nav-item">
                    <div
                        (click)="onClose.emit()"
                        ngbTooltip="Zapri"
                        class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                    >
                        <i class="la la-times"></i>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="m-portlet__body">
        <div class="d-flex align-items-center">
            <h3>
                <a [routerLink]="'/customers/view/' + customer.id" class="pr-3">{{ customer.name }} {{ customer.surname }}</a>
            </h3>
            <div class="pr-3">
                <i class="la la-phone"></i>
                {{ customer?.phone }}
            </div>
            <div class="pr-3">
                <i class="la la-envelope"></i>
                {{ customer?.email }}
            </div>
        </div>

        <ngx-datatable
            #mainTable
            [messages]="helper.ngxDataTableTransletedMessages"
            [rows]="reservatonsHistory"
            [columnMode]="'flex'"
            [rowHeight]="'auto'"
            [limit]="10"
            [footerHeight]="50"
            [selectionType]="'single'"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            class="material striped"
        >
            <ngx-datatable-column [canAutoResize]="false" [width]="140" name="Datum" prop="date">
                <ng-template ngx-datatable-cell-template let-value="value">
                    {{ value | date: 'dd.MM.yyyy HH:mm' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [flexGrow]="2" name="Status" prop="type">
                <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
                    <span *ngIf="value === 'reservations' && row?.status != 3" ngbTooltip="Rezervacija" class="m-badge m-badge--success"></span>

                    <span *ngIf="value === 'reservations' && row?.status == 3" class="m-badge m-badge--danger m-badge--wide">Preklicana</span>

                    <span *ngIf="value === 'visit'" ngbTooltip="Obravnava" class="m-badge m-badge--info"></span>
                    <span *ngIf="row?.noShow" class="m-badge m-badge--danger m-badge--wide ml-2">Odpoved</span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [flexGrow]="3" name="Komentar" prop="comment" i18n-name>
                <ng-template ngx-datatable-cell-template let-value="value">
                    {{ value || '/' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [flexGrow]="1" name="Podizvajalec" prop="subcontractorName">
                <ng-template ngx-datatable-cell-template let-value="value">
                    {{ value }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [flexGrow]="1" name="Storitev" prop="data">
                <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
                    <span *ngIf="row?.type === 'reservations'">
                        {{ value?.service?.name || '/' }}
                    </span>
                    <span *ngIf="row?.type === 'visit'">
                        <ng-container *ngIf="value?.visitService !== null && value?.visitService?.length > 0 && !value?.serviceGroup">
                            {{ (value?.visitService)[0]?.service?.name || '/' }}
                        </ng-container>

                        <ng-container *ngIf="value?.serviceGroup" ngbTooltip="Skupina storitev">
                            <span ngbTooltip="Skupina storitev" class="m-badge m-badge--brand m-badge--wide">
                                {{ value?.serviceGroup?.name || '/' }}
                            </span>
                        </ng-container>
                    </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [flexGrow]="1" name="Partner" prop="data">
                <ng-template ngx-datatable-cell-template let-value="value">
                    <common-business-subject-icon [setBsId]="value?.bsid"></common-business-subject-icon>
                    <span *ngIf="!value?.bsid">/</span>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
</div>
